import http from '@core/fetch'

export default {
  shopBond: body =>
    http('/p/wedding/index.php/admin/APIMerchantPro/bond_check', { body }),

  payBond: body =>
    http.post('/p/wedding/index.php/admin/APIMerchantPro/bond_pay', { body })
}
